import { connect } from 'react-redux'
import ConnectedLegislationFoldersMenu from 'pages/legislationfolders/ConnectedLegislationFoldersMenu'
import { setLegislationFolders, setSignUpModalIsOpen, setTiledMenuIsLoaded } from 'redux/actions'

const mapStateToProps = state => ({
  isLogged: state.user.isLogged,
  isLoaded: state.placeholders.isTiledMenuLoaded,
  aol: state.aol.name,
  isTiledMenuLoaded: state.placeholders.isTiledMenuLoaded
})

const mapDispatchToProps = dispatch => ({
  setLegislationFolders: legislationFolders => dispatch(setLegislationFolders(legislationFolders)),
  setTiledMenuIsLoaded: isLoaded => dispatch(setTiledMenuIsLoaded(isLoaded)),
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedLegislationFoldersMenu)
